module.exports = __webpack_public_path__ + "static/media/cloud-d3-v3@2x.23ca1965.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cloud-d3-v3@2x.png
// module id = 103
// module chunks = 0